module.exports = __webpack_public_path__ + "img/Twitter_hover.b56b2351.svg";